export default {
  "content": "<path d=\"M14 7.879a1.5 1.5 0 112.121 2.12A1.5 1.5 0 0114 7.88z\" fill=\"#7B61FF\"/><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M12.132 2.009l8 1.062.164.036c.37.115.646.437.696.831l1 7.937a1 1 0 01-.294.84l-9.735 9.5a1 1 0 01-1.405-.008l-8.765-8.765a1 1 0 01-.009-1.405l9.5-9.735a1 1 0 01.848-.293zM3.905 12.726l7.367 7.368 8.673-8.463-.841-6.679-6.739-.896-8.46 8.67z\" fill=\"#7B61FF\"/>",
  "attrs": {
    "width": "24",
    "height": "24",
    "viewBox": "0 0 24 24",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};